export default "__VITE_ASSET__CvWbgEMm__"